module.exports = __webpack_public_path__ + "img/oth14.209fb5f8.png";